import AjaxResolver from 'owd/module/ajax';

export default class CategoriesResolver extends AjaxResolver {
	shouldPushState() {
		return true;
	}

	pageIn() {
		const deferred = $.Deferred();

		$('.logo').each(function() {
			var html = $(this).html();
			$(this).html(html);
		});

		$('.products-list').transition({
			opacity: 1
		}, 200, 'easeOutQuad', () => {
			deferred.resolve();
		});

		

		return deferred.promise();
	}

	pageOut() {
		const deferred = $.Deferred();

		// $('.products-list').transition({
		// 	opacity: 0
		// }, 500, 'easeOutQuad', () => {
		// 	deferred.resolve();
		// });

		$('.animations-container').removeClass('inview-visible');

		setTimeout(() => {
			deferred.resolve();
		}, 1000);

		// $('body,html').animate({
		// 	scrollTop: 0
		// }, 500, 'easeOutQuad');

		return deferred.promise();
	}

	updateContent($loadedContent) {
		const deferred = $.Deferred();

		let $newContainer = $loadedContent.find('.section--products');
		let $currentContainer = $('.section--products');

		$currentContainer.after($newContainer);

		deferred.resolve([$currentContainer], [$newContainer]);

		return deferred.promise();
	}
}
